
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kpk_requisites",
      function () {
        return require("private-next-pages/kpk_requisites.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kpk_requisites"])
      });
    }
  